export default [
  {
    name: 'main',
    path: '/',
    meta: {
      layout: 'DefaultLayoutFluid',
      requireSignin: false,
      ui: {
        newHeader: true,
      },
    },
    component() {
      return import('@/pages/main/Main.vue')
    },
  },
  {
    path: '/main',
    redirect: { name: 'main' },
  },
]
